import PrefabsItem from '../PrefabsItem';
import {useGetPrefabStringV2DSQuery} from "../../../core/api/ds-prefab-api"; // Import the generic component

function PrefabsDSItem({ selectedItem, setSelectedItem }) {
    return (
        <PrefabsItem
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            useQueryHook={useGetPrefabStringV2DSQuery} // Pass the specific query hook
        />
    );
}

export default PrefabsDSItem;